import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  onefinityModelSchema,
  postUploadSchema,
  jobSetupModelSchema,
  modelToolMappingSchema,
  licenceDetailsSchema,
} from './post.schema';
import {} from '@/pages/PostUpload';
import {
  IBitUsedUnit,
  IBitType,
  IPostUploadData,
  ILaserOrEndmill,
} from '@/redux/post/post.d';

// eslint-disable-next-line import/prefer-default-export
export const usePostUploadForm = (defaultValues: IPostUploadData) => {
  return useForm<z.infer<typeof postUploadSchema>>({
    resolver: zodResolver(postUploadSchema),
    defaultValues: defaultValues as any,
    mode: 'onChange',
  });
};

export const useOnefinityModelForm = (defaultValues: IPostUploadData) => {
  return useForm<z.infer<typeof onefinityModelSchema>>({
    resolver: zodResolver(onefinityModelSchema),
    defaultValues: defaultValues as any,
    mode: 'onBlur',
  });
};

export const useLicenceDetailsForm = (defaultValues: IPostUploadData) => {
  return useForm<z.infer<typeof licenceDetailsSchema>>({
    resolver: zodResolver(licenceDetailsSchema),
    defaultValues: defaultValues as any,
    mode: 'onBlur',
  });
};

export const useModelToolMappingForm = (formData: IPostUploadData) => {
  const form = useForm<z.infer<typeof modelToolMappingSchema>>({
    defaultValues: {
      selectedModel: 0,
      toolUnit: formData.toolData?.[0]?.toolUnit || IBitUsedUnit.INCHES,
      toolUsed: formData.toolData?.[0]?.toolUsed || 0.015625,
      toolType: formData.toolData?.[0]?.toolType || IBitType.UPCUT_ENDMILL,
      laserOrEndmill:
        formData.toolData?.[0]?.laserOrEndmill || ILaserOrEndmill.ENDMILL,
    },
    resolver: zodResolver(modelToolMappingSchema),
    mode: 'onChange',
  });

  return form;
};

export const useJobSetupModelForm = (defaultValues: IPostUploadData) => {
  return useForm<z.infer<typeof jobSetupModelSchema>>({
    resolver: zodResolver(jobSetupModelSchema),
    defaultValues: defaultValues as any,
    mode: 'onBlur',
  });
};
